import React, { Component } from "react";
import { Switch, Route, Redirect, BrowserRouter } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.min.css';

import LocalStorageService from "../../../services/LocalStorageService";
import LocalDbService from "../../../services/LocalDbService";
import DataService from "../../../services/DataService";
import CoreService from "../../../services/CoreService";

import DeviceInfo from "../../lib/device/DeviceInfo"
import JwtToken from "../../lib/tokens/JwtToken";

import HomePage from "../Pages/Home/HomePage";
import AuthPage from "../Pages/Auth/AuthPage";
import ErrorPage from "../Pages/Error/ErrorPage";
import QuarantinePage from "../Pages/Quarantine/QuarantinePage";
import AddReceiptPage from "../Pages/AddReceipt/AddReceiptPage";
import UserSessionKey from "../../../models/UserSessionKey";
import { MsaReceiptStatusType } from "../../../models/MsaReceiptStatusType";
import GrowerReceiptPage from "../Pages/ViewReceipt/GrowerReceiptPage";

import TagPrintTest from "../../../data/PrintTestReceipt.json";

import "../CSS/sidenav.css";

function isOnline() {
    return navigator.onLine;
}



export default class HomeLayout extends Component {
    constructor(props) {
        super(props);
        this.deviceInfo = new DeviceInfo().getDeviceInfo();
        this.localStorageService = new LocalStorageService();
        this.localDbService = new LocalDbService();
        this.dataService = new DataService();
        this.coreService = new CoreService();

        let lastUserSession = (this.localStorageService.hasLastUserSession()) ?
            this.localStorageService.getLastUserSession() : 
            {
                isValid: false,
                gcid: "",
                uid: "",
                name: "",
                title: "",
                token: "",
                offlineTokenCanExpire: true,
                allowedScopes: [],
                isAirplaneMode: false,
                currentLocationId: null,
                locationInfo: {}
            };


        this.state =
        {
            systemErrorMsg: "",
            isLoggedIn: false,
            appInfo: {
                version:
                {
                    build: "",
                    msaApp: "",
                    msaCore: "",
                    authCore: "",
                    notificationCore: "",
                    proxy: ""
                }
            },
            onlineInfo: {
                isOnline: false, // user has network access
                isAirplaneMode: false, // user WANTS to be disconnected, even if isOnline
                isConnected: false
            }, // are we accessing network resources (because we are online AND NOT in Airplane mode)
            userSession: lastUserSession,
            userSessionKey: "",
            lastReceiptLine: null,
            copyLastLineOnAdd: true,
        }

        this.onSuccessfulLogin = this.onSuccessfulLogin.bind(this);
        this.onLogoutRequest = this.onLogoutRequest.bind(this);
        this.onErrorPageRequest = this.onErrorPageRequest.bind(this);
        this.onHomePageRequest = this.onHomePageRequest.bind(this);
        this.onAddReceiptPageRequest = this.onAddReceiptPageRequest.bind(this);
        this.onQuarantinePageRequest = this.onQuarantinePageRequest.bind(this);
        this.onPrintTagTestRequest = this.onPrintTagTestRequest.bind(this);
        this.onToggleAirplaneMode = this.onToggleAirplaneMode.bind(this);

        this.onUpdateLocationId = this.onUpdateLocationId.bind(this);
        this.onUpdateSublocationId = this.onUpdateSublocationId.bind(this);

        this.onPostDirectRequest = this.onPostDirectRequest.bind(this);
        this.onPostLocalRequest = this.onPostLocalRequest.bind(this);
        this.onLastReceiptLineChange = this.onLastReceiptLineChange.bind(this);
        this.onToggleCopyLastLineOnAdd = this.onToggleCopyLastLineOnAdd.bind(this); // we need it at this level to sustain across new receipts

        this.onRefreshUserSessionKey = this.onRefreshUserSessionKey.bind(this);

    }


    onToggleCopyLastLineOnAdd() {
        this.setState({
            copyLastLineOnAdd: !this.state.copyLastLineOnAdd
        })
    }


    async onPostDirectRequest(rcptToPost) 
    {
        rcptToPost.status.lastStatus = rcptToPost.status.flowStatus;
        rcptToPost.status.lastStatusReason = rcptToPost.status.flowStatusReason;
        rcptToPost.status.flowStatus = MsaReceiptStatusType.TOMRA; // "AWAIT-QA";
        rcptToPost.status.flowStatusReason = "Post to Core. Awaiting MRA processing.";
        rcptToPost.status.lastUpdated = moment().format();
        rcptToPost.status.lastUpdatedBy = this.state.userSession.uid;
        var postResponse = await this.coreService.postReceipt(this.state.userSession.gcid, rcptToPost, rcptToPost.transactionId, this.state.userSession.token);
        if (postResponse.hasError) {
            toast.warning("Unable to save receipt to glasschain cloud service. Saving locally...");
            var localPostResponse = await this.onPostLocalRequest(rcptToPost);

        }
        else {
            toast.success("Saved Receipt ");
        }
    }

    async onPrintTagTestRequest()
    {
        var rcptToPostJson = JSON.stringify(TagPrintTest);
        var rcptToPost = JSON.parse(rcptToPostJson);
        rcptToPost.status.lastStatus = rcptToPost.status.flowStatus;
        rcptToPost.status.lastStatusReason = rcptToPost.status.flowStatusReason;
        rcptToPost.status.flowStatus = MsaReceiptStatusType.TAGREPRINTREQUEST; 
        rcptToPost.status.flowStatusReason = "Post to Core. Awaiting MRA processing.";
        rcptToPost.status.lastUpdated = moment().format();
        rcptToPost.status.lastUpdatedBy = this.state.userSession.uid;
        var postResponse = await this.coreService.postTestTagPrintRequest(this.state.userSession.gcid, rcptToPost, this.state.userSession.uid, this.state.userSession.token);
        if (postResponse.hasError) {
            toast.warning("Problem sending Test Receipt Print Request.");
        }
        else {
            toast.success("Sent Test Receipt Print Request ");
        }
    }
    

    async onPostLocalRequest(rcptToPost) {
        rcptToPost.status.flowStatus = "OFFLINE-TOPOST";
        rcptToPost.status.flowStatusReason = "New Receipt saved offline on client";
        var postResponse = await this.LocalDbService.addReceipt(rcptToPost);
        if (postResponse.hasError) {
            // TBD - what do we do? 
            toast.error("Problem posting receipt " + rcptToPost.tagId + " to local storage.");
        }
        else {
            toast.success("Saved Receipt " + rcptToPost.tagId + ". The receipt will post when you're online again.")
            var delResponse = await this.localDbService.deleteReceipt(rcptToPost.transactionId);

        }
    }

    onLastReceiptLineChange(newReceiptLine) 
    {
        this.setState({ lastReceiptLine: newReceiptLine });
    }

    async componentDidMount() {
        // if I am connected, then I MUST log in.
        // if I am NOT connected, then I MUST have userSessionInfo stored. 
        // AND if offlineTokenCanExpire is TRUE, then the token cannot have expired.
        let onlineInfo = (isOnline()) ? 
            {
                isOnline: true, // user has network access
                isAirplaneMode: false, // user WANTS to be disconnected, even if isOnline
                isConnected: true
            } :
            {
                isOnline: false, // user has network access
                isAirplaneMode: false, // user WANTS to be disconnected, even if isOnline
                isConnected: false
            };
        /*
            if (isOnline()) {
            let onlineInfo = {
                isOnline: true, // user has network access
                isAirplaneMode: false, // user WANTS to be disconnected, even if isOnline
                isConnected: true
            }
            this.setState({
                isLoggedIn: false,
                onlineInfo: onlineInfo
            });
            //this.props.history.replace("/home/auth-page");
            //return;
        */
        this.setState({onlineInfo: onlineInfo});
        //}
        //else {

            // do we even HAVE a last userSession? 
            if (!this.localStorageService.hasLastUserSession()) {
                this.setState({ systemErrorMsg: "No User Session has ever been established on this machine!" });
                this.props.history.replace("/home/error-page");
                return;
            }
            else {
                var userSession = this.localStorageService.getLastUserSession();
                var userSessionKey = UserSessionKey.fromUserSession(userSession).toQueryString();
                if (!JwtToken.isValidToken(userSession.token)) {
                    this.setState({ systemErrorMsg: "Last Saved user Session has an invalid Jwt Token!" });
                    this.props.history.replace("/home/error-page");
                    return;
                }
                //if (this.state.userSession.offlineTokenCanExpire) {
                    if (JwtToken.isTokenExpired(userSession.token)) {
                        this.setState({ systemErrorMsg: "The Last Saved user session Jwt token has expired and your organization does allow offline use with expired tokens!" });
                        this.props.history.replace("/home/error-page");
                        return;
                    }
                //}
                let appInfo = (this.localStorageService.hasAppInfo(userSession.gcid, userSession.uid)) ?
                    this.localStorageService.getAppInfo(userSession.gcid, userSession.uid) :
                    {
                        version:
                        {
                            build: "",
                            msaApp: "",
                            msaCore: "",
                            authCore: "",
                            notificationCore: "",
                            proxy: ""
                        }
                };
                // if we got here then the user is OFFLINE AND is allowed to continue offline as the last user session
                this.setState(
                    {
                        isLoggedIn: true,
                        userSession: userSession,
                        userSessionKey: userSessionKey,
                        appInfo: appInfo
                    }
                );
            }
        //}
        this.addConnectionListeners();

        this.props.history.replace("/home/home-page");
    }

    componentWillUnmount() {
        this.removeConnectionListeners();
    }

    async onSuccessfulLogin(loginInfo) {
        // TBD: Get last user location from session or set to initial list of allowedLocations
        var userSession = {
            isValid: true,
            gcid: loginInfo.gcid, uid: loginInfo.uid, token: loginInfo.token,
            allowedLocations: loginInfo.allowedLocations,
            currentLocationId: loginInfo.currentWarehouse.warehouse.name,
            locationInfo: loginInfo.currentWarehouse
        };
        var appInfo = { version: { build: loginInfo.buildVer, msaApp: loginInfo.msaAppVer, msaCore: loginInfo.msaCoreVer, qaCore: loginInfo.qaCoreVer } };
        var newUserSessionKey = UserSessionKey.fromUserSession(userSession).toQueryString();
        console.group("In HomeLayout - onSuccessfulLogin after creating a userSession");
        console.info(userSession);
        console.groupEnd();
        this.localStorageService.saveLastUserSession(userSession);
        this.setState({
            isLoggedIn: true,
            userSession: userSession,
            appInfo: appInfo,
            userSessionKey: newUserSessionKey  // needed to trigger header panel setting proper changed location
        });
        this.localStorageService.saveAppInfo(loginInfo.gcid, loginInfo.uid, appInfo);
        this.addConnectionListeners();
        this.props.history.replace("/home/home-page");
    }

    onLogoutRequest() {
        console.log("Logging out...");
        // clean up
        this.removeConnectionListeners();
        this.localStorageService.removeLastUserSession();
        this.props.history.replace("/home/auth-page");
    }

    addConnectionListeners() {
        window.addEventListener('online', this.handleConnectionChange);
        window.addEventListener('offline', this.handleConnectionChange);
    }

    removeConnectionListeners() {
        window.removeEventListener('online', this.handleConnectionChange);
        window.removeEventListener('offline', this.handleConnectionChange);
    }

    handleConnectionChange = () => {
        let onlineInfo = {};
        const condition = navigator.onLine ? 'online' : 'offline';
        onlineInfo.isOnline = (condition === 'online');
        onlineInfo.isConnected = ((onlineInfo.isAirplaneMode !== true) && (onlineInfo.isOnline));
        console.group("OnlineInfo Change:");
        console.info(onlineInfo);
        console.groupEnd();
        this.setState({ onlineInfo: onlineInfo });
        return onlineInfo;
    }

    onHomePageRequest() {
        this.props.history.replace("/home/home-page")
    }

    onErrorPageRequest(msgs) {
        if (!msgs) {
            msgs = [""];
        }
        this.setState({ systemErrorMsg: msgs.join(" ") });
        this.props.history.replace("/home/error-page")
    }

    onQuarantinePageRequest() {
        this.props.history.replace("/home/quarantine-page")
    }



    onAddReceiptPageRequest() {
        console.log("called");
        this.props.history.replace("/home/addreceipt-page")
    }



    onToggleAirplaneMode() {
        console.group("Airplane Mode Toggle Request: ");
        console.groupEnd();
        var newOnlineInfo = this.state.onlineInfo;
        var newIsAirplaneMode = !newOnlineInfo.isAirplaneMode;
        let newIsConnected = ((newIsAirplaneMode !== true) && (newOnlineInfo.isOnline));
        newOnlineInfo.isAirplaneMode = newIsAirplaneMode;
        newOnlineInfo.isConnected = newIsConnected;
        this.setState({ onlineInfo: newOnlineInfo });

    }


    async onUpdateLocationId(newLocationId) {
        var newUserSession = this.state.userSession;
        newUserSession.currentLocationId = newLocationId;
        if (newLocationId.toLowerCase() === "all") {
            newUserSession.locationInfo = { "warehouse": { "id": "0", "name": "all" }, "sublocation": {"id": "0", "name": ""}};
        }
        else {
            // make sure dataService 
            await this.dataService.loadLocationsCatalog(this.state.userSession.gcid);
            newUserSession.locationInfo = await this.dataService.fetchLocationByName(newLocationId); // apparently we're storing them by name?
            newUserSession.locationInfo.sublocation = newUserSession.locationInfo.auxInfo.sublocations[0];
            console.group("In HomeLayout - userSession with new location info fetched from newLocationId " + newLocationId);
            console.info(newUserSession);
            console.groupEnd();
        }

        // save that user changed location for "last user"
        this.localStorageService.saveLastUserSession(newUserSession);
        var sessionKey = UserSessionKey.fromUserSession(newUserSession).toQueryString();
        this.setState({
            userSession: newUserSession,
            userSessionKey: sessionKey
        });
    }


    async onUpdateSublocationId(newSublocationId) 
    {
        var newUserSession = this.state.userSession;
        newUserSession.locationInfo.sublocation = this.state.userSession.locationInfo.auxInfo.sublocations.find(sub => sub.sublocationName === newSublocationId);
        // save that user changed location for "last user"
        this.localStorageService.saveLastUserSession(newUserSession);
        // this will NOT change the userSessionKey
        //var sessionKey = UserSessionKey.fromUserSession(newUserSession).toQueryString();
        this.setState({
            userSession: newUserSession
            //userSessionKey: sessionKey
        });
    }


    onRefreshUserSessionKey() {
        var sessionKey = UserSessionKey.fromQueryString(this.state.userSessionKey);
        sessionKey.updateRefreshKey();
        var newSessionKeyString = sessionKey.toQueryString();
        this.setState({ userSessionKey: newSessionKeyString });
    }



    render() {

        


        return (

            
            <div>
                <ToastContainer
                    position="bottom-right"
                    autoClose={3000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />

                <Switch>

                    <Route
                        path="/home/receiptview"
                        render={(props) => (
                            <GrowerReceiptPage
                                {...props}
                                token={this.state.receiptToken}
                            />
                        )}
                    />

                    <Route
                        path="/home/home-page"
                        render={(props) => (
                            <HomePage
                                {...props}
                                deviceInfo={this.deviceInfo}
                                appInfo={this.state.appInfo}
                                onlineInfo={this.state.onlineInfo}
                                userSession={this.state.userSession}
                                userSessionKey={this.state.userSessionKey} // used to trigger changes
                                onErrorPageRequest={this.onErrorPageRequest}
                                onHomePageRequest={this.onHomePageRequest}
                                onQuarantinePageRequest={this.onQuarantinePageRequest}
                                onPrintTagTestRequest = {this.onPrintTagTestRequest}
                                onLogoutRequest={this.onLogoutRequest}
                                onToggleAirplaneMode={this.onToggleAirplaneMode}
                                onUpdateLocationId={this.onUpdateLocationId}
                                onUpdateSublocationId = {this.onUpdateSublocationId}
                                onAddReceiptPageRequest={this.onAddReceiptPageRequest}
                                onRefreshUserSessionKey={this.onRefreshUserSessionKey}
                            />
                        )}
                    />

                    <Route
                        path="/home/addreceipt-page"
                        render={(props) => (
                            <AddReceiptPage
                                {...props}
                                userSession={this.state.userSession}
                                onlineInfo={this.state.onlineInfo} // does this make sense? Shouldn't we be checking in real time in case it changes?
                                onErrorPageRequest={this.onErrorPageRequest}
                                onLogoutRequest={this.onLogoutRequest}
                                onHomePageRequest={this.onHomePageRequest}
                                onPostDirectRequest={this.onPostDirectRequest}
                                onPostLocalRequest={this.onPostLocalRequest}
                                onLastReceiptLineChange={this.onLastReceiptLineChange}
                                lastReceiptLine={this.state.lastReceiptLine}
                                copyLastLineOnAdd={this.state.copyLastLineOnAdd}
                                onToggleCopyLastLineOnAdd={this.onToggleCopyLastLineOnAdd}
                            />
                        )}
                    />

                    <Route
                        path="/home/quarantine-page"
                        render={(props) => (
                            <QuarantinePage
                                {...props}
                                userSession={this.state.userSession}
                                onlineInfo={this.state.onlineInfo} // does this make sense? Shouldn't we be checking in real time in case it changes?
                                onErrorPageRequest={this.onErrorPageRequest}
                                onLogoutRequest={this.onLogoutRequest}
                                onHomePageRequest={this.onHomePageRequest}
                            />
                        )}
                    />
                    <Route
                        path="/home/auth-page"
                        render={(props) => (
                            <AuthPage
                                {...props}
                                deviceInfo={this.deviceInfo}
                                onSuccessfulLogin={this.onSuccessfulLogin}
                            />
                        )}
                    />
                    <Route
                        path="/home/error-page"
                        render={(props) => (
                            <ErrorPage
                                {...props}
                                onLogoutRequest={this.onLogoutRequest}
                                systemErrorMsg={this.state.systemErrorMsg}
                            />
                        )}
                    />
                    <Redirect from="/" to="/home/home-page" />
                    <Redirect from="/home" to="/home/home-page" />
                </Switch>

            </div>

        )
    }

}